import { useApolloClient, useLazyQuery, useSubscription } from '@apollo/client';
import {
  OutboundInterface,
  RetryFailedOutboundSubscriptionPayload,
  ToolHoundOutboundSubscriptionPayload,
} from '@bechtel/ht-types';
import { useEffect } from 'react';
import { RETRY_FAILED_OUTBOUND_SUBSCRIPTION, SEARCH_OUTBOUND_INTERFACE, TOOL_HOUND_OUTBOUND_SUBSCRIPTION } from '~/gql';

export function useOutBoundSyncSubscription() {
  const [searchOutboundInterface] = useLazyQuery<{
    outboundInterface: OutboundInterface;
  }>(SEARCH_OUTBOUND_INTERFACE, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });
  const client = useApolloClient();
  const { data: payLoadData } = useSubscription<{
    retryFailedOutbound: RetryFailedOutboundSubscriptionPayload;
  }>(RETRY_FAILED_OUTBOUND_SUBSCRIPTION);

  const { data } = useSubscription<{
    toolHoundOutBound: ToolHoundOutboundSubscriptionPayload;
  }>(TOOL_HOUND_OUTBOUND_SUBSCRIPTION);

  useEffect(() => {
    if (!payLoadData && !data) return;
    client.cache.evict({ fieldName: 'searchOutboundInterfaces' });
    //if (payLoadData.retryFailedOutbound.id) client.cache.evict({ id: payLoadData.retryFailedOutbound.id });

    client.cache.gc();
  }, [client, payLoadData, data]);

  useEffect(() => {
    if (!payLoadData && !data) return;
    searchOutboundInterface({
      variables: {
        searchInput: {
          filterInput: {
            and: [],
          },
          sortInput: [],
        },
      },
    });
  }, [payLoadData, searchOutboundInterface, data]);
}
